
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.4 15.195c-2.6-3.2-7-4.3-10.8-2.6-3.2 1.5-4.9 4.5-5.4 7.8h-3.6c-2-3.3-4-6.5-5.9-9.8-.4-.7-1.2-2.9-2.1-3.3-1.1-.6-3.7-.1-5-.1-1 0-1 3.2 0 3.2H16c.4 0 2.4.2 2.2-.1.9.7 1.6 2.7 2.2 3.6 1.3 2.2 2.6 4.3 3.9 6.5H12.2c-.4 0-.7.6-.7 1.3-.4 1.7-.5 3.5-.4 5.2-.2.8-.1 1.9.3 2.3 1.1 6.8 6.1 12.5 13.7 12.8v7.9h-4.2c-1 0-1 3.2 0 3.2h9.9c1 0 1-3.2 0-3.2h-4.2v-7.9c6.5-.3 11-4.5 13-9.9 8.1-.5 11.9-10.6 6.8-16.9zm-33.8 8.3H36c.5 0 2.9-.4 3.3 0v1.5c-3.7 1.1-8 .7-11.7.4-5.3-.4-10-.5-15.3.6 0-.8.1-1.6.3-2.5zm24.2 10c-1.3 1.7-2.9 3-4.8 3.9-7.8 3.9-17.3-.6-19.3-8.3 5.7-1.1 10.8-.7 16.7-.3 3.1.2 6.5.3 9.6-.4-.1.7-.3 1.4-.5 2-.4 1.1-1 2.1-1.7 3.1zm3.5-4.6c.1-.4.1-.8.2-1.1.4-.5.4-1.7.1-2.4 0-1.4-.2-2.8-.6-4.2-.1-.3-.2-.8-.6-.8h-7.7c1.4-5 7.9-6.9 12.2-4.1 6.2 4.1 2.5 11.6-3.6 12.6z"}})])
          )
        }
      }
    